module.exports = __webpack_public_path__ + "img/reactivar blanco.a42b3cc2.svg";